module.exports = __webpack_public_path__ + "img/banner-desktop.3a0d2b3e.jpg";